import React, { useState, useEffect } from 'react'
import { getDealerMappedinAMuAgentBycommId, SaveUpdatedMappedDealer } from '../Community/CommunityActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import PopUp from '../../../../presentationals/Popup/Popup.component'

const itemsPerPage = 10;
export default function Mapped({ ParentcommunityId }) {
    const [TableData, setTableData] = useState([])
    const [FilteredTableData, setFilteredTableData] = useState([])
    const [loader, setloader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [viewScreen, setviewScreen] = useState("Mapped");
    const [currentPage, setcurrentPage] = useState(1);
    const [searchfield, setsearchfield] = useState("")

    const getDealerMappedinAMuAgentBycommIdFunction = (viewType) => {
        if (!ParentcommunityId) return;
        const isMapped = viewType === "Mapped" ? true : false
        setloader(true)
        getDealerMappedinAMuAgentBycommId(ParentcommunityId, isMapped, "", (callback) => {
            console.log("call", callback)
            setloader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTableData(callback?.data || [])
            } else {
                setTableData([])
            }
        })
    }

    useEffect(() => {
        if (ParentcommunityId) {
            getDealerMappedinAMuAgentBycommIdFunction(viewScreen)
        }
    }, [ParentcommunityId, viewScreen])

    const handlePage = (type) => {
        setviewScreen(type)
        setcurrentPage(1)
        setsearchfield("")
    }

    const handleToggle = (id) => {
        const data = {
            "parentCommunityId": ParentcommunityId,
            "communityId": id,
            "mappedOrNot": viewScreen === "Mapped" ? false : true
        }
        setloader(true)
        SaveUpdatedMappedDealer(data, (callback) => {
            setloader(false)
            console.log("call", callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                if (viewScreen === "Mapped") {
                    setpopup({ show: true, popupStatus: "Dealer UnMapped Successfully" })
                } else {
                    setpopup({ show: true, popupStatus: "Dealer Mapped Successfully" })
                }
                getDealerMappedinAMuAgentBycommIdFunction(viewScreen)
            } else {
                setpopup({ show: true, popupStatus: "Failure" })
            }
            removePopup()
        })
    }
    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const getFilteredData = (data = TableData, search = searchfield) => {
        if (!search || typeof search !== 'string' || !search.trim()) return data || [];
        const query = search.trim().toLowerCase();
        return (data || []).filter((item) => {
            if (!item) return false;
            const communityName = String(item.communityName || '').toLowerCase();
            const firmName = String(item.firmName || '').toLowerCase();
            const communityCode = String(item.communityCode || '').toLowerCase();
            const mobileNo = String(item.mobileNo || '').toLowerCase();
            const email = String(item.email || '').toLowerCase();

            return (
                communityName.includes(query) ||
                firmName.includes(query) ||
                communityCode.includes(query) ||
                mobileNo.includes(query) ||
                email.includes(query)
            );
        });
    };

    useEffect(() => {
        const filtered = getFilteredData(TableData, searchfield);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setFilteredTableData(filtered.slice(startIndex, endIndex));
    }, [TableData, searchfield, currentPage]);

    const paginationHandler = (type) => {
        const data = getFilteredData(TableData, searchfield);
        const totalPages = Math.ceil(data.length / itemsPerPage) || 1;

        if (type === 'left') {
            if (currentPage > 1) {
                setcurrentPage((prev) => prev - 1);
            }
        }
        if (type === 'right') {
            if (currentPage < totalPages) {
                setcurrentPage((prev) => prev + 1);
            }
        }
    };

    const handleChangeSearch = (e) => {
        setsearchfield(e.target.value);
        setcurrentPage(1);
    };

    const allFiltered = getFilteredData(TableData, searchfield);
    const totalPages = Math.ceil(allFiltered.length / itemsPerPage) || 1;

    return (
        <>
            <div className='container-fluid full-height'>
                {
                    loader ? <Loader /> : ''
                }

                {
                    popup.show == true ? <PopUp popupStatus={popup.popupStatus} closePopup={closePopup} /> : ''
                }
                <div className='row'>
                    <ul className='detail-page-hr-sub-tabs' style={{ paddingTop: '10px', margin: '0' }}>
                        <li className={viewScreen === 'Mapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('Mapped')}>Mapped Dealer</li>
                        <li className={viewScreen === 'UnMapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('UnMapped')}>Unmapped Dealer</li>
                    </ul>
                </div>

                {
                    viewScreen === 'UnMapped' ?
                        <div className='row' style={{ marginTop: '20px' }}>
                            <div className="col-sm-2 col-xs-12">

                                <label>Search</label>
                                <input className='form-control' type='text' value={searchfield} onChange={(e) => handleChangeSearch(e)} placeholder='Enter Name...' />
                            </div>
                        </div>
                        : ""}

                {FilteredTableData && FilteredTableData?.length > 0 ?
                    <div style={{ marginTop: '30px' }}>
                        <div className='overflow-auto'>
                            <table className='phocket-table'>
                                <thead style={{ backgroundColor: '#182D64' }}>
                                    <tr>
                                        {/* <th>Product Id</th> */}
                                        <th>Community code</th>
                                        <th>Firm Name</th>
                                        <th>Community Name</th>
                                        <th>Mobile Number</th>
                                        <th>Email Id</th>

                                        <th>Dealer Mapped </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {FilteredTableData?.map((nbfc, i) => {
                                        return (
                                            <tr key={nbfc.communityId || i}>
                                                {/* <td>{nbfc?.productId || "-"}</td> */}
                                                <td>{nbfc?.communityCode || "-"}</td>
                                                <td>{nbfc?.firmName || "-"}</td>
                                                <td>{nbfc?.communityName || "-"}</td>
                                                <td>{nbfc?.mobileNo || "-"}</td>
                                                <td>{nbfc?.email || "-"}</td>

                                                <td>
                                                    <div className="togglableSwitch">
                                                        <label className="toggle-switch">
                                                            <input type="checkbox"
                                                                checked={viewScreen === "Mapped"}
                                                                onChange={() => handleToggle(nbfc.communityId)}
                                                            />
                                                            <div className="toggle-switch-background">
                                                                <div className="toggle-switch-handle"></div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" style={{ background: 'rgb(24, 45, 100)' }} id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                                <div className="col-sm-2 col-xs-12 phoc text-center" >Total: {currentPage}&nbsp; of &nbsp; {totalPages}</div>
                                <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" style={{ background: 'rgb(24, 45, 100)' }} id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                        </div>
                    </div>
                    : !loader ? (
                        <div style={{ marginTop: '50px', textAlign: 'center' }}>
                            <p style={{ fontSize: '16px', color: '#6c757d' }}>No {viewScreen === 'Mapped' ? 'Mapped' : 'Unmapped'} Dealer Found</p>
                        </div>
                    ) : ''}
            </div>
        </>
    )
}
